import React from "react";

import { IEditDataCellProps } from "components/dashboard/product-template-table/utils/interfaces";
import { useHasPermissions } from "hooks/useHasPermissions";
import { Button } from "primereact/button";
import { confirmPopup } from "primereact/confirmpopup";
import { T } from "services/lang/LanguageService";
import "./CustomIconButton.scss";

export default function EditDataCell(props: IEditDataCellProps) {
  const hasPermission = useHasPermissions("easas.product_templates.signature-override");
  
  const acceptDelete = () => {
    props.onClickDelete(props.index);
  };

  const acceptCopy = () => {
    props.onClickCopy(props.index);
  };

  const reject = () => {};

  const deleteConfirm = (event: any) => {
    confirmPopup({
      target: event.currentTarget,
      message: T("confirm-dialog.do-you-want-to-delete-this-entry"),
      icon: "pi pi-exclamation-triangle",
      acceptClassName: "p-button-danger",
      accept: acceptDelete,
      reject,
    });
  };

  const copyConfirm = (event: any) => {
    confirmPopup({
      target: event.currentTarget,
      message: T("confirm-dialog.do-you-want-to-copy-this-entry"),
      icon: "pi pi-copy",
      acceptClassName: "p-button-success",
      accept: acceptCopy,
      reject,
    });
  };

  return (
    <span
      className="edit-buttons"
      style={{
        display: "flex",
        flexWrap: "nowrap",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {props.isInEditMode ? (
        <>
          <div>
            <Button
              icon="pi pi-save"
              className="p-button-text"
              onClick={() => props.onClickSave(props.index)}
            />
          </div>
          <div>
            <Button
              icon="pi pi-times"
              className="p-button-text"
              onClick={() => props.onClickCancel(props.index)}
            />
          </div>
        </>
      ) : (
        <>
          <div>
            <Button
              icon="pi pi-pencil"
              className="p-button-text"
              onClick={() => props.onClickEdit(props.index)}
              disabled={!hasPermission && !!props.signedBy}
              tooltip={
                props.signedBy
                  ? T("message.entry-locked-editing-disabled-signed-by", {
                      signedBy: props.signedBy,
                    })
                  : ""
              }
              tooltipOptions={{ showOnDisabled: true }}
            />
          </div>
          <div>
            <Button
              icon="pi pi-copy"
              className="p-button-text"
              onClick={copyConfirm}
            />
          </div>
        </>
      )}
      {props.deletable && (
        <Button
          icon="pi pi-trash"
          className="p-button-text p-button-danger"
          onClick={deleteConfirm}
        />
      )}
    </span>
  );
}
